function setupClosingElement(baseClassName) {
  const element = document.querySelector(baseClassName);
  const openButton = document.querySelector(baseClassName + "__open");
  const closeButton = document.querySelector(baseClassName + "__close");
  if (!element || !openButton || !closeButton) return;
  openButton.addEventListener("click", () => {
    element.classList.remove("close");
  });
  closeButton.addEventListener("click", () => {
    element.classList.add("close");
  });
}

function setupMenuAnimation() {
  const links = document.querySelectorAll(".na-menu__links > li");
  if (!links.length) return;
  const animDUR = 200;
  const slowdownFactor = 20;
  const initDELAY = 400;

  let delay = initDELAY;
  links.forEach((link, idx) => {
    const duration = animDUR + slowdownFactor * idx;
    link.style.animationDelay = `${delay}ms`;
    link.style.animationDuration = `${duration}ms`;
    delay += duration;
  });
}

function setupSubmenus() {
  document.querySelectorAll(".na-menu__link--parent").forEach((btn) => {
    btn.addEventListener("click", () => {
      const expanded = btn.getAttribute("aria-expanded") === "true";
      btn.setAttribute("aria-expanded", !expanded);
      btn.nextElementSibling.classList.toggle("open");
    });
  });
}

setupClosingElement("#na-menu"); // MENU
setupClosingElement("#na-search"); // SEARCH
setupMenuAnimation();
setupSubmenus();
